// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadButton-cls1_ljS","cls2":"DownloadButton-cls2_kSa DownloadButton-cls1_ljS"};